module.exports = __webpack_public_path__ + "static/content-bb77ff38b24b3c00f1dcdc5c697010a1.png";